// Generic option source for node pickers.
//
// The catalog owns the request shape (`control_options.request`: endpoint, method and a `query`
// map of templates). This module only substitutes the placeholders, appends the client id and
// pagination values, and reads the response fields the catalog names — so no picker is
// service-specific.
import { adminRequest } from "./adminRequest";
import { buildOptionsRequest } from "../utils/nodeBuilder";

export const DEFAULT_OPTIONS_ENDPOINT = "/admin/node-options";

/**
 * @param {object} params
 * @param {object} [params.controlOptions] The `control_options` block from the catalog.
 * @param {string|null} [params.source] The selected source (for `{source}` templates).
 * @param {object} [params.data] The node's resolved data (for `{field}` templates).
 * @param {string|null} [params.clientId]
 * @param {string|number|null} [params.cursor]
 * @param {number|null} [params.limit]
 */
export const getNodeOptions = async ({
  controlOptions = {},
  source = null,
  data = {},
  clientId = null,
  cursor = null,
  limit = null,
} = {}) => {
  const { endpoint, method, query, optionsField, cursorField } = buildOptionsRequest({
    controlOptions,
    source,
    data,
    clientId,
    cursor,
    limit,
  });

  const queryString = new URLSearchParams(query).toString();
  const result = await adminRequest(method, queryString ? `${endpoint}?${queryString}` : endpoint);

  return {
    ...result,
    source: result?.source ?? source ?? null,
    options: Array.isArray(result?.[optionsField]) ? result[optionsField] : [],
    next_cursor: result?.[cursorField] ?? null,
  };
};

export default getNodeOptions;
